<template>
  <div>
    <span class="heading tx-16">
      <strong>Datos del auto</strong>
    </span>
    <div class="container py-2">
      <table
        class="table__datasheet tx-14 xl:tx-16 spacing-0 border-collapse w-full"
      >
        <tr class="row" v-if="product.year">
          <th class="heading w-2/4 tx-left">
            <span class="uppercase"> Color </span>
          </th>
          <td class="cell w-2/4 tx-right">
            <span class="opacity-70">
              {{ product.color.title }}
            </span>
          </td>
        </tr>
        <tr class="row" v-if="product.interior_color_id">
          <th class="heading w-2/4 tx-left">
            <span class="uppercase"> Color interior </span>
          </th>
          <td class="cell w-2/4 tx-right">
            <span class="opacity-70">
              {{
                product.interior_color_id != 0
                  ? product.interior_color_id
                  : "Sin color"
              }}
            </span>
          </td>
        </tr>
        <tr class="row">
          <th class="heading w-2/4 tx-left">
            <span class="uppercase">
              {{ product.owners > 1 ? "Dueños" : "Dueño" }}
            </span>
          </th>
          <td class="cell w-2/4 tx-right">
            <span class="opacity-70">
              {{ product.owners > 1 ? product.owners : "Único" }}
            </span>
          </td>
        </tr>
        <tr class="row">
          <th class="heading w-2/4 tx-left">
            <span class="uppercase"> I.V.A. </span>
          </th>
          <td class="cell w-2/4 tx-right">
            <span class="opacity-70">
              {{ product.iva > 0 ? "si" : "no" }}
            </span>
          </td>
        </tr>
      </table>
    </div>
    <hr />

    <div v-if="product.specs">
      <span class="tx-16 py-0">
        <strong>Características</strong>
      </span>
      <div class="container py-2" v-if="product.specs">
        <table
          class="table__datasheet tx-14 xl:tx-16 spacing-0 border-collapse w-full"
          
        >
          <tr v-for="(spec, index) in specs" :key="index" class="row" >
            <td class="cell w-2/4 tx-left" v-if="spec.value !== 'false'">
              <span  v-if="spec.value == 'true' || spec.value == true">
                {{ $t(spec.name) }}
              </span>
              <span v-else-if="spec.value != 'false'">
                {{ `${ $t(spec.name) } - ${ spec.value }` }}
              </span>
            </td>
          </tr>
          <hr class="p-0 m-0" />
        </table>
      </div>
      <div class="tx-center">
        <button
          v-show="btnFlag"
          @click="showMore"
          class="btn btn--green-ad py-2 px-5 ml-2 m-2"
        >
          VER MÁS
        </button>
        <button
          v-show="!btnFlag"
          @click="showLess"
          class="btn btn--green-ad py-2 px-5 ml-2 m-2"
        >
          VER MENOS
        </button>
      </div>
      <hr class="m-0" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    limit: 8,
    btnFlag: true,
  }),
  computed: {
    specs() {
      let res = [];
      if (this.product.specs === null) {
        return res;
      }
      const json_data = JSON.parse(this.product.specs.specs);
      for (let i in json_data) {
        json_data[i].name =
          json_data[i].name.charAt(0).toUpperCase() +
          json_data[i].name.substr(1);
        res.push(json_data[i]);
      }
      res = _.orderBy(res, ["name"], ["asc"]);
      return res.length < this.limit ? res : res.slice(0, this.limit);
    },
  },
  methods: {
    showMore() {
      this.btnFlag = false;
      this.limit = 1000;
    },

    showLess() {
      this.btnFlag = true;
      this.limit = 8;
    },
  },
};
</script>
